import React from "react";
import cx from "clsx";
import { Box } from "../../../../../../../../shared/Box/Box";
import styles from "./styles.module.scss";
import { useContext } from "../../../../context";
import { InputQuestion } from "./InputQuestion";
import { InputDescription } from "./InputDescription";
import { Choices } from "./Choices";
import { DragIcon } from "../../../../../../../../shared/DragIcon/DragIcon";

const Block = ({ id, required, markContent, children }) => {
  const { focusedBlock } = useContext();

  const active = focusedBlock.id === id && Boolean(id);

  const focus = () => {
    if (id) {
      focusedBlock.set(id);
    }
  };

  return (
    <Box
      className={cx(styles.root, { [styles.rootActive]: active })}
      onClick={focus}
    >
      <div className={styles.left}>
        {!!id && <DragIcon className={styles.draggable} />}
        <div className={cx(styles.mark, { [styles.markActive]: active })}>
          {markContent}
        </div>
      </div>
      <div className={styles.content}>{children}</div>
      {required && <span className={styles.required}>*</span>}
    </Box>
  );
};

Block.Question = InputQuestion;
Block.Description = InputDescription;
Block.Choices = Choices;

export { Block };
